import React, { CSSProperties, RefObject } from 'react';
import { Alert } from '@mui/material';
import { FilesStats } from 'new/elements/ReadStats/components/FilesStats';
import { FileItems } from 'new/elements/ReadStats/components/FileItems';
import { CronItems } from 'new/elements/ReadStats/components/CronItems';
import { TaskItems } from 'new/elements/ReadStats/components/TaskItems';
import { FILE_LIST_MODE_TYPES } from 'js/constants/paginationConstants';
import useFileItems from 'new/elements/ReadStats/hooks/useFileItems';

interface ReadStatsProps {
  resourceType: string;
  resourceId: string;
  useFiles: boolean;
  hideStats?: boolean;
  requestOnMount?: boolean;
  parentScrollRef?: RefObject<any>;
  connectionCategory: string;
  onFilePreviewClicked?: (props: any) => void;
  data?: any;
  mode: keyof typeof FILE_LIST_MODE_TYPES;
  isAdaptiveFlow?: boolean;
}

const style: CSSProperties = { position: 'relative' };

export const ReadStats = (props: ReadStatsProps) => {
  const { useFiles, hideStats, mode = FILE_LIST_MODE_TYPES.MODE_READ, isAdaptiveFlow } = props;
  const fileItems = useFileItems(props.resourceId, props.resourceType, false, isAdaptiveFlow);

  const renderContent = () => {
    const showCronItems = !useFiles;
    if (showCronItems) return <CronItems {...props} />;

    const showFilesStats = !hideStats;

    return (
      <>
        {showFilesStats && (
          <FilesStats
            key="read-stats-file-stats"
            {...props}
            mode={mode}
            requestFiles={fileItems.requestFiles}
          />
        )}

        {isAdaptiveFlow ? (
          <TaskItems key="read-stats-task-items" {...props} {...fileItems} />
        ) : (
          <FileItems key="read-stats-file-items" {...props} {...fileItems} />
        )}
      </>
    );
  };

  return (
    <div aria-label="read-stats" style={style}>
      <Alert
        severity="info"
        sx={{ mx: '16px', mt: '16px', '& .MuiAlert-icon': { color: 'info.dark' } }}
      >
        Stats are available for the last 3 months only. Contact support with any questions.
      </Alert>
      {renderContent()}
    </div>
  );
};
